import { matchPath } from 'react-router-dom';

import {
  AUTOTASK_POD,
  AUTOTASK_POD_FULL_SIZE,
  CONNECTWISE_POD,
  FRESH_SERVICE_FULL_SIZE,
  FRESH_SERVICE_POD,
  HALO_POD,
  IMPORT_INTEGRATION_POD,
  KASEYA_POD,
  MICROSOFT_365_POD,
  SERVICE_NOW_POD,
  SUPER_OPS_POD,
  SYNCRO_POD,
  ZENDESK_POD,
} from 'router/routes';

const POD_PREFIX = '/pod';

const PREFIXED_POD_ROUTES = [
  AUTOTASK_POD,
  AUTOTASK_POD_FULL_SIZE,
  CONNECTWISE_POD,
  FRESH_SERVICE_POD,
  FRESH_SERVICE_FULL_SIZE,
  HALO_POD,
  IMPORT_INTEGRATION_POD,
  KASEYA_POD,
  MICROSOFT_365_POD,
  SERVICE_NOW_POD,
  SUPER_OPS_POD,
  SYNCRO_POD,
  ZENDESK_POD,
];

// PSA pod links live in the customer's PSA config, so a link generated without the
// /pod prefix cannot be recalled. Accept it and resolve it to the real route.
export const resolvePodDeepLink = (pathname: string, search = ''): string | null => {
  if (pathname.startsWith(`${POD_PREFIX}/`)) {
    return null;
  }

  const prefixed = `${POD_PREFIX}${pathname}`;

  return PREFIXED_POD_ROUTES.some(route => matchPath(route, prefixed))
    ? `${prefixed}${search}`
    : null;
};
